import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { IEffect } from '../../actions/effects/IEffect';
import { app } from '../../app';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getMatch2AssetPath } from '../../util/assets';
import { blockViewAssets } from '../../util/blockTools';
import { RainbowSoapBlockEntity } from './RainbowSoapBlockEntity';
import { RainbowBubbleBlockEntity } from '../../entities/BlockEntity';
import { PositionType } from '../../../lib/defs/types';
import { config } from '../../defs/config';
import gsap from 'gsap';

export class RainbowSoapBlockEffect implements IEffect {
  private readonly scene: GameScene;

  constructor(scene: GameScene) {
    this.scene = scene;
  }

  public static assets() {
    return blockViewAssets('rainbowSoap');
  }

  public async execute() {
    //
  }

  public async animateBreak(entity: RainbowSoapBlockEntity) {
    const container = new Container();
    const movieclip = new MovieClip({
      superview: container.view,
      url: getMatch2AssetPath('blocks/rainbowSoap'),
    });
    const overlay = spawnOverlayEntity(
      this.scene,
      entity.c.position.mapPosition,
      entity.c.block.props,
      () => container,
      'foreground',
    );
    app.sound.play('puzzle-bubble-destroy');
    await movieclip.playAsync('rainbow_soap_spawn');
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateBreakParticles(entity: RainbowSoapBlockEntity) {
    const textures: string[] = [
      getMatch2AssetPath('blocks/rainbowSoap/9.png'),
      getMatch2AssetPath('blocks/rainbowSoap/11.png'),
      getMatch2AssetPath('blocks/rainbowSoap/14.png'),
      getMatch2AssetPath('blocks/rainbowSoap/17.png'),
    ];

    const particles = app.particles.create({
      textures,
      rate: 0,
      limit: 7,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -400 },
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 300] },
        { type: 'gravity', gravity: { x: 0, y: 2000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateSpawnedBubble(
    bubble: RainbowBubbleBlockEntity,
    origin: PositionType,
    delay: number,
  ) {
    const view = bubble.c.view2d.view;
    const position = bubble.c.position.mapPosition;
    const distanceX = position.x - origin.x;
    const distanceY = position.y - origin.y;
    const from = {
      x: view.x - distanceX * config.tile.size,
      y: view.y - distanceY * config.tile.size,
    };
    const to = {
      x: view.x,
      y: view.y,
    };
    const fromScale = { scaleX: 0.1, scaleY: 0.1 };
    const toScale = { scaleX: view.scaleX, scaleY: view.scaleY };
    const duration = 0.3;
    view.scaleX = fromScale.scaleX;
    view.scaleY = fromScale.scaleY;
    view.x = from.x;
    view.y = from.y;
    view.alpha = 0.5;
    app.sound.play('puzzle-bubble-form', { dupes: 4 });
    gsap.to(view, { ...toScale, alpha: 1, duration, ease: 'back.out', delay });
    await gsap.to(view, { ...to, duration, ease: 'quad.out', delay });
  }
}
